import React from 'react';
import { useSelector } from 'react-redux';

import { Spinner } from 'react-bootstrap';

import './table.scss';
import Players from '../players/Players';
import InsideTable from './InsideTable/InsideTable';
import ChosenSuitComp from './ChosenSuit/chosenSuitComp';
import ClockComp from './Clock/ClockComp';
import CheatVoteComp from './cheatVote/CheatVoteComp';
import { store } from '../../index';

function Table({ twoVstwo }) {
	const currentlyInGame = useSelector((state) => state.ingame);
	const clockActive = useSelector((state) => state.hand.clock);
	const showCheatVote = useSelector((state) => state.clock.showCheatVote);

	// console.log(currentlyInGame);

	window.onpopstate = () => {
		console.log('popstate..');
		// TODO: You should leave the game here..
		store.dispatch({ type: 'LEAVE_GAME' });
	};

	return (
		<div className="area">
			<div className="table">
				{/*
				 */}
				{showCheatVote ? <CheatVoteComp /> : ''}

				{/*  */}
				{!currentlyInGame ? (
					<div className="loading-game">
						<div className="child">
							<Spinner animation="border" size="lg" variant="danger" />
						</div>
						<div className="child">
							<span>Finding Game..</span>
						</div>
					</div>
				) : (
					''
				)}
			</div>
			<span id="myclock">
				<ClockComp active={clockActive} />
			</span>

			<ChosenSuitComp />
			{currentlyInGame ? <InsideTable twoVstwo={twoVstwo} /> : ''}
			{currentlyInGame ? <Players twoVstwo={twoVstwo} /> : ''}
		</div>
	);
}

export default Table;
